import { KernButton } from '@kern-ux-annex/kern-react-kit'
import { useNavigate } from 'react-router'

export function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-start gap-16 py-48">
      <h1 className="kern-heading kern-heading-large">Seite nicht gefunden</h1>
      <p className="kern-body">Die aufgerufene Adresse gibt es in Drittmittelscan nicht.</p>
      <KernButton variant="primary" label="Zu den Maßnahmen" onClick={() => void navigate('/massnahmen')} />
    </div>
  )
}
